import { Outlet } from "react-router";

import Header from "./components/Header";
import { ReactNode } from "react";
import { useWhiteLabel } from "@hooks/useWhiteLabel";

import "./Landing.scss";

/** public layout */
interface LandingProps {
  authPage?: boolean;
  children?: ReactNode;
}
const Landing = ({ authPage, children }: LandingProps) => {
  const { config } = useWhiteLabel();

  const content = (
    <div className="landing-layout d-width-100 d-flex-column d-scroll-x-hidden">
      <Header authPage={authPage} />
      <div className="landing-layout__content d-width-100 d-height-fit d-flex d-flex-wrap d-align-center d-justify-center d-pt-48 d-bg-neutral-50">
        {children}
        <Outlet />
      </div>
    </div>
  );

  return config ? <>{content}</> : content;
};

export default Landing;
